import { lazy, Suspense } from 'react';
import { CircularProgress } from '@mui/material';

import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';
import RoutePrivate from 'components/common/route-private';
import { config } from 'config';

const ContentsOnOff = lazy(() => import('components/GAME_MANAGEMENT/contentsOnOff'))

const MaintenanceSchedule = lazy(() => import('components/GAME_MANAGEMENT/maintenance/schedule'))
const LeagueExpired = lazy(() => import('components/GAME_MANAGEMENT/maintenance/expireLeagues'))

const SystemNotice = lazy(() => import('components/GAME_MANAGEMENT/message/systemNotice'))
const MessageNotice = lazy(() => import('components/GAME_MANAGEMENT/message/notice'))
const TouPP = lazy(() => import('components/GAME_MANAGEMENT/message/touPP'))
const OperatorPayment = lazy(() => import('components/GAME_MANAGEMENT/message/operatorPayment'))

const Gateways = lazy(() => import('components/GAME_MANAGEMENT/gateway/gateways'))
const GatewayV1 = lazy(() => import('components/GAME_MANAGEMENT/gateway/gateways_v1'))
const Blacklist = lazy(() => import('components/GAME_MANAGEMENT/gateway/blacklist'))
const Whitelist = lazy(() => import('components/GAME_MANAGEMENT/gateway/whitelist'))
const Staging = lazy(() => import('components/GAME_MANAGEMENT/gateway/staging'))

const LeagueConfig = lazy(() => import('components/GAME_MANAGEMENT/league/leagueConfig'))
const LeagueData = lazy(() => import('components/GAME_MANAGEMENT/league/leagueData'))
const LeagueSchedule = lazy(() => import('components/GAME_MANAGEMENT/league/leagueSchedule'))

const AttendanceRewardConfig = lazy(() => import('components/GAME_MANAGEMENT/attendance/rewardsConfig'))
const Attendance = lazy(() => import('components/GAME_MANAGEMENT/attendance/control'))

const MainEvents = lazy(() => import('components/GAME_MANAGEMENT/event/main'))
const QuestMission = lazy(() => import('components/GAME_MANAGEMENT/mission'))
const MiniGame = lazy(() => import('components/GAME_MANAGEMENT/minigame'))

const BingoBallRewards = lazy(() => import('components/GAME_MANAGEMENT/bingoBall/dailyReward'))
const BingoBallLeagues = lazy(() => import('components/GAME_MANAGEMENT/bingoBall/league'))
const BingoBallSchedule = lazy(() => import('components/GAME_MANAGEMENT/bingoBall/schedule'))

const CashMine = lazy(() => import('components/GAME_MANAGEMENT/cashMine'))

const PromoCoupon = lazy(() => import('components/GAME_MANAGEMENT/promoCode/promoCoupon'))
const InviteControl = lazy(() => import('components/GAME_MANAGEMENT/promoCode/inviteControl'))
const InviteQuest = lazy(() => import('components/GAME_MANAGEMENT/promoCode/inviteQuest'))

const Segment = lazy(() => import('components/GAME_MANAGEMENT/segment'))
const OneLink = lazy(() => import('components/GAME_MANAGEMENT/onelink'))
const PushSchedule = lazy(() => import('components/GAME_MANAGEMENT/push'))
const PrizeRanking = lazy(() => import('components/GAME_MANAGEMENT/prizeRanking'))
const ModeratePictures = lazy(() => import('components/GAME_MANAGEMENT/moderatePictures'))
const WinnersTip = lazy(() => import('components/GAME_MANAGEMENT/winnersTip'))

const GameManagement = () => {
  let { path } = useRouteMatch();

  return (
    <Suspense fallback={<CircularProgress />}>
      <Switch>
        <RoutePrivate exact path={`${path}/contents`} component={ContentsOnOff} permission='VIEWER' />

        <RoutePrivate exact path={`${path}/maintenance/schedule`} component={MaintenanceSchedule} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/maintenance/leagueexpired`} component={LeagueExpired} permission='VIEWER' />

        <RoutePrivate exact path={`${path}/message/systemnotice`} component={SystemNotice} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/message/notice`} component={MessageNotice} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/message/toupp`} component={TouPP} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/message/operatorpayment`} component={OperatorPayment} permission='VIEWER' />

        <RoutePrivate exact path={`${path}/gateway/gateway_v1`} component={GatewayV1} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/gateway/gateways`} component={Gateways} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/gateway/staging`} component={Staging} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/gateway/whitelist`} component={Whitelist} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/gateway/blacklist`} component={Blacklist} permission='VIEWER' />

        <RoutePrivate exact path={`${path}/league/config`} component={LeagueConfig} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/league/data`} component={LeagueData} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/league/schedule`} component={LeagueSchedule} permission='VIEWER' />

        <RoutePrivate exact path={`${path}/attendance/config`} component={AttendanceRewardConfig} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/attendance/control`} component={Attendance} permission='VIEWER' />

        <RoutePrivate exact path={`${path}/event/data`} component={MainEvents} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/mission`} component={QuestMission} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/minigame`} component={MiniGame} permission='VIEWER' />

        <RoutePrivate exact path={`${path}/bingoball/rewards`} component={BingoBallRewards} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/bingoball/leagues`} component={BingoBallLeagues} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/bingoball/schedule`} component={BingoBallSchedule} permission='VIEWER' />

        <RoutePrivate exact path={`${path}/promocode/promocoupon`} component={PromoCoupon} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/promocode/invitecontrol`} component={InviteControl} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/promocode/invitequest`} component={InviteQuest} permission='VIEWER' />

        <RoutePrivate exact path={`${path}/cashmine`} component={CashMine} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/segment`} component={Segment} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/onelink`} component={OneLink} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/pushschedule`} component={PushSchedule} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/prizeranking`} component={PrizeRanking} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/moderatepictures`} component={ModeratePictures} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/winnerstip`} component={WinnersTip} permission='VIEWER' />

        <Route path='*'>
          <Redirect to={`/${config.game}/dashboard/notfound`} />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default GameManagement;
